// https://firebase.google.com/docs/analytics/get-started?platform=web
import { initializeApp } from "firebase/app";
import "firebase/database";
import "firebase/messaging";
import {
    logEvent,
    getAnalytics,
} from "firebase/analytics";
import {
    GoogleAuthProvider,
    getAuth,
    signInWithPopup,
    signInWithEmailAndPassword,
    // createUserWithEmailAndPassword,
    sendPasswordResetEmail,
    onAuthStateChanged,
    signOut,
} from "firebase/auth";
// import {
//     getFirestore,
//     query,
//     getDocs,
//     collection,
//     where,
//     addDoc,
//   } from "firebase/firestore";

// Initalize and export Firebase.
const firebaseDevConfig = {
    apiKey: "AIzaSyA6PFVgJXTHosqwcW-mQykVYtUM-h0FcV0",
    authDomain: "bookweb-asia-dev.firebaseapp.com",
    projectId: "bookweb-asia-dev",
    storageBucket: "bookweb-asia-dev.appspot.com",
    messagingSenderId: "543407534071",
    appId: "1:543407534071:web:7a93aa0a1bc6a8e7fec8f2",
    measurementId: "G-D65HETHBKS"
};
const firebaseConfig = {
    apiKey: "AIzaSyCCVpNpa6SMYeOJVvHEs0jn1Dum7PVFSBY",
    authDomain: "bookweb-asia-prd.firebaseapp.com",
    projectId: "bookweb-asia-prd",
    storageBucket: "bookweb-asia-prd.appspot.com",
    messagingSenderId: "225911673057",
    appId: "1:225911673057:web:bb4cbb25dc453b396767a0",
    measurementId: "G-KLK6YVGN77"
};
let firebaseApp;
let auth;
// let db;
let analytics;
const appEnv = process.env.REACT_APP_APP_ENV;
if (
    typeof window !== "undefined" &&
    (!firebaseApp || !firebaseApp.apps.length)
) {
    firebaseApp = initializeApp(
        appEnv === "prd"
            ? firebaseConfig
            : firebaseDevConfig
    );
    auth = getAuth(firebaseApp);
    // db = getFirestore(firebaseApp);
    analytics = getAnalytics(firebaseApp);
}

const signInWithGoogle = async () => {
    try {
        const googleProvider = new GoogleAuthProvider();
        const res = await signInWithPopup(auth, googleProvider);
        const user = res.user;
        // const q = query(collection(db, "users"), where("uid", "==", user.uid));
        // const docs = await getDocs(q);
        // if (docs.docs.length === 0) {
        //     await addDoc(collection(db, "users"), {
        //         uid: user.uid,
        //         name: user.displayName,
        //         authProvider: "google",
        //         email: user.email,
        //     });
        // }
        return user;
    } catch (err) {
        console.error(err);
        // alert(err.message);
        return null;
    }
};

const logInWithEmailAndPassword = async (email, password) => {
    try {
        await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};

const handleAuthStateChanged = async () => {
    onAuthStateChanged(auth, (user) => {
        if (user) {
            // User is signed in, see docs for a list of available properties
            // https://firebase.google.com/docs/reference/js/firebase.User
            const uid = user.uid;
            // ...
        } else {
            // User is signed out
            // ...
        }
    });
};

const sendPasswordReset = async (email) => {
    try {
        await sendPasswordResetEmail(auth, email);
        alert("Password reset link sent!");
    } catch (err) {
        console.error(err);
        alert(err.message);
    }
};

const logout = () => {
    signOut(auth);
};

export {
    firebaseApp,
    auth,
    signInWithGoogle,
    logInWithEmailAndPassword,
    sendPasswordReset,
    onAuthStateChanged,
    handleAuthStateChanged,
    logout,
    analytics,
    logEvent,
};
